module.exports = __webpack_public_path__ + "img2.daadd59.png";